import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5f3d44a6")

_pushScopeId("data-v-5f3d44a6")
const _hoisted_1 = { class: "backContainer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("main", null, [
    _createVNode("header", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, { click: _ctx.goBack }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["click"])
      ]),
      _createVNode("h1", null, _toDisplayString(_ctx.appName), 1),
      _hoisted_3
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.appComponent)))
  ]))
})